var bundiscount_var2 = parseInt("{{ settings.discount_quantity2 | plus: 0}}");
var bundiscount_var1 = parseInt("{{ settings.discount_quantity1 | plus: 0}}");
var bundiscount_var = parseInt("{{ settings.discount_quantity | plus: 0}}");
  function checkcart(line,quantity,upqty ){
$.getJSON("/cart.json", function(cart) {
  var count_bundle = 0,_Bundle_id=""; 
  $.each(cart.items, function(ci, item) {
    if (item.properties._Bundle_id != undefined && item.properties._Bundle_id.indexOf(item.id) > -1) {ci++;
      if(line == ci){
         count_bundle = count_bundle + parseInt(quantity);
      }else{
        count_bundle = count_bundle + item.quantity;
      }
      }
    /*
    if(_Bundle_id=''){
      _Bundle_id = item.properties._Bundle_id;
      if (item.properties._Bundle_id != undefined && item.properties._Bundle_id.indexOf(item.id) > -1) {
        count_bundle++;
      }
    }
    else{
      if (item.properties._Bundle_id != undefined){
        if(item.properties._Bundle_id.indexOf(item.id) > -1 && item.properties._Bundle_id == _Bundle_id) {
        count_bundle++;
        }else if(item.properties._Bundle_id != _Bundle_id){
          _Bundle_id = item.properties._Bundle_id;
          var count_bundle = 0;
          count_bundle++;
        }
      }
    } 
    */
  });
  if( parseInt(bundiscount_var2) <= count_bundle){
   var discountcode = '{{settings.discount_per2}}';
  }else if(parseInt(bundiscount_var1) <= count_bundle){
    var discountcode = '{{settings.discount_per1}}';
  }else if(parseInt(bundiscount_var) <= count_bundle){
    var discountcode = '{{settings.discount_per}}';
  }
  if(upqty == 'true'){
  $.getJSON("/cart.json", function(cart) {
      let count_budle = 0;
      let allProducts = [];var upd_qty = '';
      $.each(cart.items, function(ci, item) {
          ci++;
          if (item.properties._Bundle_id != undefined && item.properties._Bundle_id.indexOf(item.id) > -1) {
              if(line == ci){
                  upd_qty = parseInt(quantity);
              count_budle = count_budle + parseInt(quantity);
              }else{
                  upd_qty = item.quantity;
                  count_budle = count_budle + item.quantity;
              }
              allProducts.push({
                  "line":ci,
                  "properties":{
                      '_Bundle_id': item.properties._Bundle_id,
                      '_Bundle_Discount':discountcode
                  }
              })
              var bundle_data = {
                  line: ci,
                  quantity:upd_qty,
                  properties:{
                      '_Bundle_id': item.properties._Bundle_id,
                      '_Bundle_Discount':discountcode
                  }
              };
  
              $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: bundle_data,
                  dataType: "json",
                  async: false,
                  cache: false,
                  success:function(resultData) {
                      console.log("resultData count",resultData);
                  }
              });
              // jQuery.post('/cart/change.js', { properties: { _Bundle_id: item.properties._Bundle_id, _Bundle_Discount: discountcode }, line: ci });
              // fetch('/cart/change.json', {
              //     method: 'POST',
              //     headers: {
              //         'Content-Type': 'application/json'
              //     },
              //     body: JSON.stringify({
              //         line:ci,
              //         quantity:upd_qty,
              //         properties:{
              //             '_Bundle_id': item.properties._Bundle_id,
              //             '_Bundle_Discount':discountcode
              //         }
              //     })
              // })
              // .then((response) => {
              //     console.log('response',response);
              //   })
          }
      });
      let formData = {
          'items': allProducts,
      }
      // var discountcode = '10%'
      // if(count_budle >= 6){
      //     var discountcode = '20%'
      // }
      // let variantIDArray = JSON.parse(bundle);
      
      // let formData = {
      //     'items': allProducts,
      // }; console.error('formData:', formData);   
     
  });
}
 
});
  }


